import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IProcessBuyListInput,
  IProcessBuyListResult,
} from '@shared/models/buyers-list';

export const PROCESS_BUY_LIST: TypedDocumentNode<
  IProcessBuyListResult,
  IProcessBuyListInput
> = gql`
  mutation processBuyList($input: ProcessBuyListInput) {
    processBuyList(input: $input)
  }
`;
